import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListTMBR = createAsyncThunk(
  "TeamMemberNameList/fetchListTMBR",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/salesmen/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const TeamMemberNameListSlice = createSlice({
  name: "TeamMemberNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListTMBR.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListTMBR.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListTMBR.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default TeamMemberNameListSlice.reducer;
